var _circle, _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountActivationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 74,
    r: 74,
    fill: "#FF5F14"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.23,
    y: 54.39,
    width: 89.54,
    height: 37.74,
    rx: 18.87,
    fill: "#FF5F14",
    stroke: "white",
    strokeWidth: 5.18
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 89.17,
    y: 62.5299,
    width: 21.46,
    height: 21.46,
    rx: 10.73,
    fill: "white",
    stroke: "white",
    strokeWidth: 5.18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.62 73.6932L54.9837 82.14L66.6 62.9",
    stroke: "white",
    strokeWidth: 5.18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountActivationIcon);
export default __webpack_public_path__ + "static/media/accountActivationIcon.ee6aba9b1e3adb56a77b80db306aa11c.svg";
export { ForwardRef as ReactComponent };